(function ($) {
  // Show the video on the hero section.
  $(".toggle-video").on("click", function () {
    $(".video-container").fadeIn("slow");
    $("body").css("overflow", "hidden");
  });

  $(".close-video").on("click", function () {
    $(".video-container").fadeOut("slow");
    $("body").css("overflow", "auto");
  });
})(jQuery);
